import { render, staticRenderFns } from "./TransportItem.vue?vue&type=template&id=5c0c48d8&"
import script from "./TransportItem.vue?vue&type=script&lang=js&"
export * from "./TransportItem.vue?vue&type=script&lang=js&"
import style0 from "./TransportItem.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports